import { Pipe, PipeTransform } from '@angular/core';

@Pipe({

  name: 'displayToUserPipe',
  standalone: false,
})
export class DisplayToUserPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(items: any[]): any[] {
    if (items) {
      return items.filter(item => (item.rule && item.rule.displayToUser) || item.displayToUser);
    } else {
      return [];
    }
  }
}
